import { ArrowLongLeftIcon } from "@heroicons/react/24/outline";
import Button, { EButtonVariant } from "components/elements/Button";
import Typography, { ITypo } from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

import classes from "./classes.module.scss";
import { container } from "tsyringe";
import ModuleConfig from "configs/ModuleConfig";
import { GenericProduct } from "common/resources/Scpi/PhysicalPerson/GenericProduct";
import classNames from "classnames";

export type ISubscriptionSteps = {
	category: keyof GenericProduct;
	path: string;
	title: string;
};

const modules = container.resolve(ModuleConfig).get().modules;

type IProps = {
	onClickedLink: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, path: string) => void;
	checkCategoryIsCompleted: (category: keyof GenericProduct) => boolean;
	signDocumentStepEnabled: boolean;
	signDocumentStepActive: boolean;
	steps: ISubscriptionSteps[];
	subscriptionId: string;
};

export default function SubscriptionQuestionsStepper(props: IProps) {
	const navigate = useNavigate();
	const location = useLocation();

	const navigateToSubscription = useCallback(() => {
		navigate(modules.pages.Subscriptions.props.pages.InProgress.props.path);
	}, [navigate]);

	const signatureDocumentPath = modules.pages.Subscriptions.props.pages.SubscriptionQuestions.pages.ValidateRto.props.path.replace(":subscriptionId", props.subscriptionId);
	const validaitionStepperPath = modules.pages.Subscriptions.props.pages.SubscriptionQuestions.pages.ValidateDocuments.props.path.replace(":subscriptionId", props.subscriptionId);
	return (
		<div className={classes["stepper-left"]}>
			<div className={classes["stepper-container"]}>
				<Button variant={EButtonVariant.TEXT} className={classes["back-button"]} onClick={navigateToSubscription}>
					<ArrowLongLeftIcon className={classes["back-icon"]} />
					{I18n.asset.pages.subscriptions.back_to_subscriptions}
				</Button>
				{props.steps.map((step, index) => (
					<Link
						key={index}
						className={classes["step"]}
						onClick={(e) => props.onClickedLink(e, step.path)}
						to={step.path}
						data-selected={!!matchPath(step.path, location.pathname)}
						data-completed={props.checkCategoryIsCompleted(step.category)}>
						<Typography typo={ITypo.P_SMALL} className={classes["step-number"]}>
							{index + 1}
						</Typography>
						<Typography typo={ITypo.P_SMALL} className={classes["step-title"]}>
							{step.title}
						</Typography>
					</Link>
				))}
				{props.signDocumentStepEnabled && (
					<Link
						className={classNames(classes["step"], !props.signDocumentStepActive && classes["disabled"])}
						to={props.signDocumentStepActive ? signatureDocumentPath : "#"}
						data-selected={!!matchPath(signatureDocumentPath, location.pathname) || !!matchPath(validaitionStepperPath, location.pathname)}
						data-completed={false}>
						<Typography typo={ITypo.P_SMALL} className={classes["step-number"]}>
							{props.steps.length + 1}
						</Typography>
						<Typography typo={ITypo.P_SMALL} className={classes["step-title"]}>
							{I18n.asset.pages.subscriptions.validation_documents.page_title}
						</Typography>
					</Link>
				)}
			</div>
		</div>
	);
}
